import * as React from "react";
type Props = {
  className?: string,
};
function SvgSupplementsContainer({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-supplementsContainer"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.01538 20.5C-6.20671 28.4619 19.0267 43.7679 22.2257 35.4187C25.4251 27.0694 41.2629 26.3918 39.1329 14.9592C37.0029 3.52662 22.4645 -0.368457 15.5946 1.41198C8.72471 3.19241 10.8474 13.7382 3.01538 20.5Z"
        fill="#D6E4EE"
      />
      <path
        d="M21.74 16.6404V33.8404C21.74 34.1104 21.52 34.3304 21.25 34.3304H6.48C6.22 34.3304 6 34.1104 6 33.8504V16.6404C6 14.7704 7.32 13.2204 9.07 12.8504V10.9004H18.66V12.8404C20.42 13.2104 21.74 14.7704 21.74 16.6404Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M7.33984 10.93H20.3798C20.4798 10.93 20.5598 10.84 20.5398 10.74L19.9298 6.88C19.8498 6.38 19.4198 6 18.9098 6H8.82984C8.31984 6 7.88984 6.37 7.80984 6.87L7.17984 10.74C7.15984 10.84 7.23984 10.93 7.33984 10.93Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M10.1494 7.15039V9.86039"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M12.21 7.15039V9.86039"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M19.0695 28.3997H8.65945C8.39945 28.3997 8.18945 28.1897 8.18945 27.9297V18.6897C8.18945 18.4297 8.39945 18.2197 8.65945 18.2197H19.0695C19.3295 18.2197 19.5395 18.4297 19.5395 18.6897V27.9297C19.5395 28.1897 19.3295 28.3997 19.0695 28.3997Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M34.2997 22.4596V33.7396C34.2997 33.9396 34.1397 34.0996 33.9397 34.0996H24.3297C24.1297 34.0996 23.9697 33.9396 23.9697 33.7396V22.4596C23.9697 20.7796 24.8497 19.2996 26.1797 18.4696C26.5497 18.2396 26.7597 17.8196 26.7597 17.3896V16.0596H31.4897V17.3896C31.4897 17.8296 31.6997 18.2396 32.0797 18.4696C33.4197 19.2996 34.2997 20.7696 34.2997 22.4596Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M25.1396 16.06H33.1296V13.92C33.1296 13.28 32.6096 12.75 31.9596 12.75H26.3396C25.6996 12.75 25.1796 13.26 25.1696 13.9L25.1396 16.06Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M26.6699 13.5195V15.3395"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M28.0498 13.5195V15.3395"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M31.1399 12.7599H27.1299V8.90988C27.1299 7.92988 27.9199 7.12988 28.9099 7.12988H29.3699C30.3499 7.12988 31.1499 7.91988 31.1499 8.90988V12.7599H31.1399Z"
        fill="white"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M32.1202 31.0102H26.1502C26.0202 31.0102 25.9102 30.9002 25.9102 30.7702V22.2302C25.9102 22.1002 26.0202 21.9902 26.1502 21.9902H32.1202C32.2502 21.9902 32.3602 22.1002 32.3602 22.2302V30.7702C32.3602 30.9102 32.2602 31.0102 32.1202 31.0102Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgSupplementsContainer;
